/**
 * The **Animal Alert** vocabulary — a call to other viewers to come and look now. Ephemeral: the
 * API holds one for at most three minutes in a Redis window and never writes it to the media, so
 * changing this list needs no migration and no API release.
 *
 * Distinct from a **Media Tag** (`@/components/ShareModal/Tagging/constants`), which is durable and
 * enum-validated. `Cute Alert` used to be a tag and is now an alert; media tagged with the old
 * value keep it.
 */
export const ANIMAL_ALERT_TYPES = [
  'Cute Alert!',
  'LOL!',
  'Zoomies!',
  'Beautiful!',
  'Chaos!',
  'Cozy!',
  'Get a room!',
  'Looking at me?',
] as const;

export type AnimalAlertType = (typeof ANIMAL_ALERT_TYPES)[number];

export const ANIMAL_ALERT_COOLDOWN_MS = 180_000;
